var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboardIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14L17 14",
    stroke: "#64B664",
    strokeWidth: 1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 14H7.5",
    stroke: "#64B664",
    strokeWidth: 1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 10.5H7.5",
    stroke: "#64B664",
    strokeWidth: 1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 17.5H7.5",
    stroke: "#64B664",
    strokeWidth: 1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 10.5H17",
    stroke: "#64B664",
    strokeWidth: 1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 17.5H17",
    stroke: "#64B664",
    strokeWidth: 1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 3.5C8 2.67157 8.67157 2 9.5 2H14.5C15.3284 2 16 2.67157 16 3.5V4.5C16 5.32843 15.3284 6 14.5 6H9.5C8.67157 6 8 5.32843 8 4.5V3.5Z",
    stroke: "#64B664",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 16.0002C21 18.8286 21 20.2429 20.1213 21.1215C19.2426 22.0002 17.8284 22.0002 15 22.0002H9C6.17157 22.0002 4.75736 22.0002 3.87868 21.1215C3 20.2429 3 18.8286 3 16.0002V13.0002M16 4.00195C18.175 4.01406 19.3529 4.11051 20.1213 4.87889C21 5.75757 21 7.17179 21 10.0002V12.0002M8 4.00195C5.82497 4.01406 4.64706 4.11051 3.87868 4.87889C3.11032 5.64725 3.01385 6.82511 3.00174 9",
    stroke: "#64B664",
    strokeWidth: 1,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "20px",
    width: "50px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 620 620",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(60) translate(-150, 90)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M304.749,19.727c-2.014-2.073-4.931-2.969-7.773-2.414c-2.833,0.563-5.187,2.517-6.262,5.196l-11.083,27.729 c-1.681,4.198-6.331,6.356-10.622,4.923l-18.753-6.254c-4.658-1.553-7.047-6.706-5.23-11.262l10.341-25.852 c1.015-2.542,0.751-5.418-0.708-7.73c-1.459-2.312-3.942-3.78-6.672-3.959C221-1.662,193.101,19.369,188.323,44.973 c-1.553,8.319-1.766,25.135,15.084,39.878c0.776,0.683,1.681,1.229,2.645,1.613c7.397,2.909,16.714,5.759,28.607,8.284 c34.196,8.003,56.951,8.856,72.103,6.749c1.595-0.222,3.114-0.896,4.334-1.954c2.781-2.406,5.111-4.991,6.834-7.696 C331.412,70.628,322.001,37.422,304.749,19.727z",
    fill: "#000"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M307.087,468.574c0-0.068,0.034-0.136,0.026-0.205c-0.162-1.408-0.307-2.816-0.469-4.223 c-0.145-1.177-0.154-2.397-0.392-3.549c-15.852-142.918-9.121-275.077-0.725-331.141c0.768-5.119-3.114-9.752-8.293-9.837 c-2.193-0.043-4.292-0.085-5.87-0.085c-15.886,0-35.706-2.346-60.432-8.131c-2.389-0.512-4.701-1.041-6.945-1.604 c-5.964-1.476-11.45,3.797-10.298,9.829c13.096,68.409,23.07,218.647,8.216,348.742c-0.009,0.077,0.026,0.154,0.017,0.23 c0,0.247-0.077,0.486-0.077,0.734c0,23.523,19.137,42.66,42.66,42.66c23.522,0,42.66-19.137,42.66-42.66 C307.164,469.077,307.096,468.83,307.087,468.574z M264.513,494.938c-14.035,0-25.442-11.356-25.57-25.357 c0.213-1.911,0.41-3.848,0.614-5.768c2.542-11.458,12.747-20.067,24.956-20.067c12.167,0,22.337,8.549,24.922,19.939 c0.222,1.962,0.427,3.925,0.648,5.887C289.955,483.582,278.548,494.938,264.513,494.938z",
    fill: "#000000"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardIcon);
export default __webpack_public_path__ + "static/media/clipboardIcon.cead25d3a3db454220adf2eb72b6206a.svg";
export { ForwardRef as ReactComponent };